if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}

import "/src/css/site.css"

console.log("Hi, Yahzee!")

import Alpine from "alpinejs"
import focus from "@alpinejs/focus"
import lightbox from "alpine-tailwind-lightbox"

Alpine.plugin(focus)
Alpine.plugin(lightbox)
Alpine.start()

import Glide from "@glidejs/glide"

if (document.querySelector(".glide") != null) {
  new Glide(".glide", {
    type: "carousel",
    autoplay: 3000,
  }).mount()
}

import Aos from "aos"

Aos.init({
  mirror: true,
  once: false
})
